<template>
  <section class="bill-wrapper">
    <div class="order_list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-checkbox-group ref="checkboxGroup">
          <van-cell-group v-for="(item, index) in orders" :key="index" class="order_list__group">
            <!-- 停车场、复选框 -->
            <van-cell @click.stop="showInvoice(item)">
              重发发票
              <template slot="title">
                <span style="white-space:nowrap;">{{item.parkName}}</span>
              </template>
            </van-cell>
            <!-- 基础信息 -->
            <van-cell :title="item.cardNumber" :label="item.orderPayTime">
              <div slot="default" class="order_list__group__price">
                ¥
                <div class="order_list__group__price__integer">
                  {{ item.orderMoney}}
                </div>

              </div>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </van-list>
    </div>
  </section>
</template>

<script>
import { List, CellGroup, Checkbox, CheckboxGroup, SubmitBar } from 'vant'
import { getBillingHistory } from '@/api/park'
import { SetIssuer } from '@/api/invoice'

export default {
  props: {
    orders: {
      type: Array,
      default () {
        return {}
      }
    },
    params: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  components: {
    [List.name]: List,
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [SubmitBar.name]: SubmitBar,
  },
  data () {
    return {
      totalPrice: 0,
      loading: false, //加载中。。。
      finished: false, //结束所有状态
    }
  },
  methods: {
    // 重开发票弹窗
    showInvoice (val) {
      SetIssuer({ parkId: Number(val.parkId) }).then(res => {
        if (!res.body) {
          this.$toast.fail('暂无销售方信息');
        } else {
          this.$router.push({ name: 'Invoice-Again' })
          this.$store.dispatch('invoice/SetPendingBill', [val])
        }
      }).catch(err => {
        this.$notify({
          type: 'danger',
          message: err
        })
      })
    },
    onLoad () {
      if (this.orders.length < 9999999) {
        this.loading = true
        this.finished = true
      } else {
        this.params.startPage++
        getBillingHistory(this.params).then(res => {
          let data = res.body
          data.forEach(element => {
            // if (typeof element.paidMoney === 'number') {
            //   element.priceArr = element.paidMoney.toFixed(2).split('.')
            // }
            // else {
            //   element.paidMoney = element.paidMoney.slice(0, element.paidMoney.length - 2) + '.' + element.paidMoney.slice(element.paidMoney.length - 2)
            //   element.priceArr = (element.paidMoney - 0).toFixed(2).split('.')
            // }
            this.orders.push(element)
          });
          this.loading = false
          this.finished = false
        }).catch(err => {
          this.$notify({
            type: 'danger',
            message: err
          })
        })
      }
    },
  }
}
</script>


<style lang="scss" scoped>
.bill-wrapper {
  height: 100vh;
  background-color: #f5f5f5;

  .order_list {
    overflow-y: auto;
    padding: 0 8px 0;
    height: calc(100vh - 84px - 1px);
    &__group {
      margin: 5px 0 5px;

      &__price {
        color: #4b62ec;
        font-weight: 500;
        font-size: 12px;

        &__integer {
          display: inline-block;
          font-size: 20px;
          font-family: Avenir-Heavy, PingFang SC, Helvetica Neue, Arial,
            sans-serif;
        }
      }
    }
  }

  .order_handler {
    /deep/ .van-submit-bar__tip,
    &__tip {
      color: #444444;
      background-color: #ffffff;
      border-bottom: 1px solid #f5f5f5;

      &__num {
        color: #f56723;
      }
    }
  }
}
</style>